module.exports = {"511703001":"三里坪街道","511703002":"翠屏街道","511703005":"明月江街道","511703006":"杨柳街道","511703100":"亭子镇","511703101":"福善镇","511703102":"麻柳镇","511703104":"大树镇","511703105":"南岳镇","511703106":"万家镇","511703107":"景市镇","511703108":"百节镇","511703109":"赵家镇","511703113":"渡市镇","511703114":"管村镇","511703115":"石梯镇","511703116":"石桥镇","511703117":"堡子镇","511703118":"平滩镇","511703120":"双庙镇","511703122":"赵固镇","511703123":"桥湾镇","511703125":"大堰镇","511703127":"罐子镇","511703203":"安仁乡","511703217":"龙会乡","511703234":"虎让乡","511703235":"米城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511703.json
// module id = 2504
// module chunks = 0